const comments = [
  {
    name: '影视爱好者小陈',
    text: '用了今日看料两年多了，每天打开首页就能看到最新的热门内容推荐，找片效率高了很多。官网入口一直很稳定，收藏夹必备！',
    tag: '资深用户',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Asian%20man%20with%20warm%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20minimalist%20headshot%20style%2C%20slight%20smile&width=96&height=96&seq=avatar-01&orientation=squarish',
  },
  {
    name: '纪录片控阿琳',
    text: '知识科普频道简直是我的宝藏！纪录片推荐质量很高，更新也很及时。希望今日看料越做越好，会一直支持下去的。',
    tag: '忠实用户',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20young%20Asian%20woman%20with%20gentle%20smile%2C%20soft%20diffused%20natural%20light%2C%20clean%20white%20background%2C%20minimalist%20professional%20headshot%2C%20friendly%20approachable%20expression&width=96&height=96&seq=avatar-02&orientation=squarish',
  },
  {
    name: '追番少年小杰',
    text: '动漫频道的追番日历太好用了，再也不用到处找更新信息了。首页导航很清楚，各个板块一目了然，体验很流畅。',
    tag: '活跃用户',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20a%20young%20Asian%20teenager%20boy%20with%20bright%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20minimalist%20headshot%20photography%2C%20warm%20approachable%20look&width=96&height=96&seq=avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            用户评价
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            听听用户们怎么说今日看料
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200 cursor-default"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{comment.name}</div>
                  <span className="inline-block mt-0.5 text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {comment.tag}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{comment.text}"
              </p>
              <div className="mt-3 flex text-amber-400 text-sm">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}